import { EgretLoadable } from "egret";

const settings = {
  activeLayout: "layout1",
  layout1Settings: {
    topbar: {
      show: false,
      showcontent: true,
      backgroudColor: "#ececec",
    },
    navbar: { show: false },
    leftSidebar: {
      show: true,
      mode: "compact",
    },
  },
  layout2Settings: {
    mode: "full",
    topbar: {
      show: false,
    },
    navbar: { show: false },
  },
  secondarySidebar: { show: false },
  footer: { show: false },
};

const schedule = EgretLoadable({
  loader: () => import("./index"),
});

const PurchaseLisanceRoute = [
  {
    path: "/purchase-license",
    component: schedule,
    settings,
  },
];

export default PurchaseLisanceRoute;
